import {CodebookModel} from '../models/codebook.model';

export class ActionTypeCodebook {
    static allTypes:CodebookModel[] = [
        {
            id:1,
            name:'ActionType-Create'
        } , {
            id:2,
            name:'ActionType-EditApplication'
        } , {
            id:3,
            name:'ActionType-AssignedIsbnAutomaticaly'
        } , {
            id:4,
            name:'ActionType-AssignedIsbnManualy'
        } , {
            id:5,
            name:'ActionType-AcceptedPrints'
        } , {
            id:6,
            name:'ActionType-DeletedISBN'
        } , {
            id:101,
            name:'ActionType-ISBNReport'
        } ,
        {
            id:102,
            name:'ActionType-printsReport'
        } , {
            id:200,
            name:'ActionType-IsbnChangedReport'
        }
    ];
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/codebook/action-type-codebook.ts